<div
  #dropdownRef
  [ngClass]="{ 'phx-filter': phxStyleType === 'filter', 'phx-select-wrapper': !phxTriggerTemplate }"
  [phxDropdownFor]="optionsDropdown"
  [phxDropdownWidth]="dropdownWidth"
  [phxTrigger]="'click'"
  [phxPosition]="phxPlacement"
  [phxBackdrop]="true"
  [(phxVisible)]="phxOpen"
  [phxClickHide]="!phxMultiple"
  [phxDisabled]="disabled"
  [phxDropdownClassName]="dropdownClasses"
  [phxDropdownOffset]="phxDropdownOffset"
  (phxVisibleChange)="onDropdownToggle($event)"
>
  <ng-container *ngIf="!phxTriggerTemplate">
    <ng-container *ngIf="phxPrefixIcon" [ngTemplateOutlet]="prefixIcon"></ng-container>
    <ng-container [ngSwitch]="optionList?.hasSelectedOption">
      <div *ngSwitchCase="false" class="phx-select-placeholder">
        {{ phxPlaceholder }}
      </div>
      <ng-container *ngSwitchCase="true">
        <ng-container *ngIf="!phxMultiple">
          <div class="phx-select-value">
            <ng-container [ngTemplateOutlet]="phxLabelTemplate || selectedOptionLabel" [ngTemplateOutletContext]="{ $implicit: optionList?.templatesContext }">
            </ng-container>
          </div>
        </ng-container>
        <ng-container *ngIf="phxMultiple">
          <ng-container [ngSwitch]="phxDisplayTypeInMultiMode">
            <div *ngSwitchCase="'tag'" class="phx-select-currently-selected-tags-container">
              <phx-tag
                *ngFor="let opt of optionList?.selectedOptionsForUI; index as i"
                [phxSuffixIcon]="CrossIcon"
                [disabled]="disabled"
                [phxSize]="phxSize"
                (phxOnClick)="removeTag($event, opt, i)"
              >
                {{ opt.label }}
              </phx-tag>
            </div>
            <ng-container *ngSwitchCase="'badge'">
              <div class="phx-select-value">
                <ng-container
                  [ngTemplateOutlet]="phxLabelTemplate || selectedOptionLabel"
                  [ngTemplateOutletContext]="{ $implicit: optionList?.templatesContext }"
                ></ng-container>
              </div>
              <phx-badge *ngIf="phxShowCounter" phx-tooltip [phxContent]="optionList.tooltipTitle" [phxCount]="optionList.triggerOptionCount"></phx-badge>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-template #selectedOptionLabel>{{ selectLabel }}</ng-template>
    <div class="phx-select-dropdown-suffix">
      <ng-container *ngIf="optionList?.hasSelectedOption && phxShowSelectCrossIcon; else chevronIcon">
        <button
          phx-icon-button
          [phxIcon]="CrossIcon"
          [disabled]="disabled"
          phxIconButtonSize="extra-extra-small"
          class ="phx-selection-clear-icon"
          (click)="clearSelection($event)"
        ></button>
      </ng-container>
      <ng-template #chevronIcon>
        <i phx-icon [phxIcon]="ChevronDownIcon"></i>
      </ng-template>
    </div>
  </ng-container>
  <ng-container [ngTemplateOutlet]="phxTriggerTemplate" [ngTemplateOutletContext]="{ $implicit: optionList?.templatesContext }"></ng-container>
</div>

<phx-dropdown #optionsDropdown>
  <phx-selection-list
    [phxVirtualScrollEnabled]="phxVirtualScrollEnabled"
    [phxTruncateSubText]="phxTruncateSubText"
    [phxMinBufferMultiplier]="10"
    [phxMaxBufferMultiplier]="20"
    [phxOptions]="phxOptions"
    [phxDataSource]="phxDataSource"
    [phxSearchPlaceholder]="phxSearchPlaceholder"
    [phxShowSearch]="phxShowSearch"
    [phxFocusSearchOnOpen]="phxFocusSearchOnOpen"
    [phxLoading]="phxLoading"
    [phxMultiple]="phxMultiple"
    [phxResultNotFound]="phxResultNotFound"
    [phxShowRadio]="phxShowRadio"
    [phxShowSubText]="phxShowSubText"
    [phxFilterPredicate]="phxFilterPredicate"
    [phxEmitOnlyIndependentSelections]="phxEmitOnlyIndependentSelections"
    [phxSearchDebounceTime]="phxSearchDebounceTime"
    [phxSelectionChangeDebounceTime]="phxSelectionChangeDebounceTime"
    [phxOptimisticSelection]="phxOptimisticSelection"
    [phxAllowClear]="phxAllowClear"
    [phxListHeight]="phxDropdownHeight"
    [phxServerSearch]="phxServerSearch"
    [phxEnableAddNewOption]="phxEnableAddNewOption"
    [phxNewOptionValidation]="phxNewOptionValidation"
    [phxFooterRightTemplate]="phxFooterRightTemplate"
    [phxPreventSelection]="phxPreventSelection"
    [phxHighlightSubtext]="phxHighlightSubtext"
    [phxSearchText]="phxSearchText"
    [phxShowFirstOptionFocused]="phxShowFirstOptionFocused"
    [phxDisableParentSelection]="phxDisableParentSelection"
    [phxShowOnlyIndependentSelections]="phxShowOnlyIndependentSelections"
    [ngModel]="selectedValue"
    (ngModelChange)="onValueChange($event)"
    (phxClear)="onClear()"
    (phxOptionClick)="onOptionClick()"
    (phxAddOptionClick)="onAddOptionClick($event)"
    (phxLinkOptionClick)="onLinkOptionClick($event)"
    (phxSelectionChange)="phxSelectionChange.emit($event)"
    (phxSearchChange)="phxSearchChange.emit($event)"
    (phxScrollEnd)="phxScrollEnd.emit($event)"
    (phxFocus)="phxFocus.emit($event)"
    (phxBlur)="phxBlur.emit($event)"
    (phxFocusTrigger)="onFocusTrigger()"
  ></phx-selection-list>
</phx-dropdown>

<ng-template #prefixIcon>
  <div class="phx-select-prefix-icon">
    <ng-container [ngTemplateOutlet]="phxPrefixIcon"></ng-container>
  </div>
</ng-template>
